import _ from 'lodash'
import documenti from '@/services/documentiService.js'

export const emailed = async function (documentoId, destinatario, copiaCarbone) {
  try {
    const documento = await documenti.getDocumento(documentoId)
    if (documento) {
      documento.editInfo = documento.editInfo || {}
      documento.editInfo.emailed = documento.editInfo.emailed || []
      documento.editInfo.emailed.push({ data: new Date(), destinatario: destinatario, copiaCarbone: copiaCarbone || null })
      await documenti.aggiornaDocumento(documento)
    }
  } catch {
  }
}

export const buildOggetto = function (item, oggetto) {
  let stg = oggetto
  var v
  do {
    v = getParametro(stg, '{{', '}}')
    if (v) {
      const defaultV1 = ''
      stg = stg.replace(`{{${v}}}`, _.get(item, v) || defaultV1)
    }
  }
  while (v)
  return stg
}

export const buildDestinatario = function (item, destinatario) {
  const to = []
  const tdd = destinatario.split(',')
  for (const td of tdd) {
    let nome = ''
    let email = ''
    let sede = null
    switch (td) {
      case 'fatture':
        email = _.get(item, 'fatturazione.emailInvio') || ''
        nome = _.get(item, 'ragioneSociale') || email
        if (email) to.push({ nome, email })
        break
      case 'pec':
        email = _.get(item, 'fatturazione.pec') || ''
        nome = _.get(item, 'ragioneSociale') || email
        if (email) to.push({ nome, email })
        break
      case 'sede':
        sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
        if (sede) {
          email = sede.email || ''
          nome = email // TODO: Prevedere una Descrizione del recapito
          if (email) to.push({ nome, email })
        }
        break
      case 'recapiti':
        break
      case 'primoCompilato':
        email = _.get(item, 'fatturazione.emailInvio') || ''
        nome = _.get(item, 'ragioneSociale') || email
        if (!email) {
          email = _.get(item, 'fatturazione.pec') || ''
          nome = _.get(item, 'ragioneSociale') || email
        }
        if (!email) {
          sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
          if (sede) {
            email = sede.email || ''
            nome = email
          }
        }
        if (email) to.push({ nome, email })
        break
      case 'tutti':
        email = _.get(item, 'fatturazione.emailInvio') || ''
        nome = _.get(item, 'ragioneSociale') || email
        if (email) to.push({ nome, email })
        email = _.get(item, 'fatturazione.pec') || ''
        nome = _.get(item, 'ragioneSociale') || email
        if (email) to.push({ nome, email })
        sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
        if (sede) {
          email = sede.email || ''
          nome = email
          if (email) to.push({ nome, email })
        }
        break
      default:
        break
    }
  }
  return to
}

const getParametro = function(valore, inizio, fine) {
  const a = valore.indexOf(inizio)
  const b = valore.indexOf(fine || inizio)
  const v = a > -1 ? valore.substring(a + 2, b) : ''
  return v
}
